import e from "@dialpad/dialtone-tokens/layered/themes/tokens-winter-gold-colors.css?inline";
//#region themes/winter-gold.js
var t = {
	brand: {
		css: e,
		name: "winter-gold"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
